import gql from "graphql-tag";

const GET_CURRENT_BLOG = gql`
    query Blog($blog: ID!){
        blog(id: $blog){
            id,
            title,
            content, 
            createdAt
            description
            blog_categories{
                category
            }
            preview{
                url
            }
        }
        socialAccount{
            shop
            instagram
        }
    }
`
export default GET_CURRENT_BLOG